var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_732_2999",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_732_2999",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAB6klEQVR4nO3cS07DQBBF0YIlwSDsjMxgyGZB7AAGyZMiK3b6Z3dV9z2SZyA57yYK2FHMAAAAAAAAAAAAENbZzE69T6KBk10eSyifZvZnZr9m9tb5XGq8mtmPXR7LV+dzSabxdUSNcDu+DvcRluNHjXBvfPcR1saPFmFrfLcRzrZ9wrcRPL8xn+xyjimPxdUb84uZfVt6BI+vhJRnvusnUuQI4ceXiBGGGV8iRRhufIkQYdjxxXOE4ccXjxGmGV88RZhufPEQYdrxpWeE6ceXHhEYf+HICIy/4ogIjP/AnhEYP9EeERg/U8sIjF+oRQTGr1QTgfEbKYnA+I3l3Jf9zfxZxk+U80pg/J20isD4FWojMH4DpREYv6HcCGHGf+59Aomerkfu76CBnL/zt/5ZQ4HS8YnQQO34RKjQanwiFOBSREclF9Y8fORlCDVXNYlQqcUlZSIUank9nwiZ9riZQoREe97JIsIDR9xGJMKKI+/hEmGhxw10Ilz1/PTC9BE8fHRk2ggexpfpIngaX6aJ4HF8GT6C5/Fl2AgRxpfhIkQaX4aJEHF8CR8h8vgSOgJfWebAu8UeX1JeCR/dzu6BtQhRxpetCG7Hl2WEaOPLvQjuxxdFiDq+3EYIM77w5d0AAAAAAAAAAADo7x8LJKAQgSH97QAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBtn);
export default __webpack_public_path__ + "static/media/delete-btn.056120c69082cd216753df5bf03dea63.svg";
export { ForwardRef as ReactComponent };